module.exports = {"513332100":"尼呷镇","513332101":"洛须镇","513332102":"色须镇","513332103":"虾扎镇","513332104":"温波镇","513332105":"蒙宜镇","513332106":"阿日扎镇","513332200":"真达乡","513332201":"奔达乡","513332202":"正科乡","513332204":"德荣马乡","513332206":"长沙贡马乡","513332207":"呷衣乡","513332208":"格孟乡","513332210":"新荣乡","513332211":"宜牛乡","513332213":"起坞乡","513332215":"长须贡马乡","513332216":"长沙干马乡","513332217":"长须干马乡","513332219":"瓦须乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513332.json
// module id = 2554
// module chunks = 0